// =============================================================
// SyncButton  Phase 4
// Button to trigger Google API synchronization with loading state
// =============================================================

import React from 'react';

interface Props {
  onSync: () => Promise<void>;
  loading: boolean;
  disabled?: boolean;
  lastSyncedAt?: string | null;
  label?: string;
  sourceLabel?: string;
}

export const SyncButton: React.FC<Props> = ({
  onSync,
  loading,
  disabled = false,
  lastSyncedAt,
  label = 'Sync Now',
  sourceLabel,
}) => {
  return (
    <div className="sync-button-wrap" style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
      <button
        type="button"
        className="btn btn-secondary btn-sm"
        onClick={onSync}
        disabled={disabled || loading}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px',
          fontWeight: 600,
        }}
      >
        {loading ? (
          <>
            <span
              className="spinner"
              style={{
                width: '14px',
                height: '14px',
                border: '2px solid rgba(0,0,0,0.1)',
                borderTopColor: 'currentColor',
                borderRadius: '50%',
                display: 'inline-block',
                animation: 'spin 0.8s linear infinite',
              }}
            />
            <span>Syncing 28d Data...</span>
          </>
        ) : (
          <>
            <span></span>
            <span>{label}</span>
          </>
        )}
      </button>

      {lastSyncedAt && (
        <span
          style={{
            fontSize: '0.75rem',
            color: '#6b7280',
            textAlign: 'center',
          }}
        >
          {sourceLabel && <strong>[{sourceLabel}] </strong>}
          Synced: {new Date(lastSyncedAt).toLocaleString()}
        </span>
      )}
    </div>
  );
};
